import React from 'react';
import { observer } from 'mobx-react';
import { ConnectionGroupsListVM } from './connection-groups-list.viewmodel';
import classnames from 'classnames';
import { ADD_CONNECTION_GROUP_BTN_TEXT, CONNECTION_GROUPS_TEXT } from './connection-groups.texts';
import DefaultButton from '../../../../global/default-button/default-button';
import { ConnectionGroupListItem } from './connection-group-list-item';
import { hasPermission } from '../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../api/roles.dao';
import { OERadioSingleOption } from '../../../../global/oe-radio-options/oe-radio-single-option';
import { DELETE_TEXT, editText } from '../../../../../constants/common-labels.constants';

type ConnectionGroupsListPresentationProps = {
    vm: ConnectionGroupsListVM;
};

const editButtonText = editText();

export const ConnectionGroupsListPresentation = observer((props: ConnectionGroupsListPresentationProps): JSX.Element => {
    const { vm } = props;
    const createGroupPermission = hasPermission(Permission.CREATE_CONNECTION_GROUPS);
    const editGroupPermission = hasPermission(Permission.EDIT_CONNECTION_GROUPS);
    const deleteGroupPermission = hasPermission(Permission.DELETE_CONNECTION_GROUPS);

    const openAddConnectionGroupPopup = (): void => {
        if (vm.isNewGroupPopupOpened) return;
        vm.openAddConnectionGroupPopup();
    };

    return (
        <div className={classnames('connection-list', { 'connection-list__meeting-connections': vm.isMeetingConnectionForm })}>
            <div className='connection-list__label-wrapper'>
                <div className={classnames('connection-list__label', { 'connection-list__label--wide': vm.isMeetingConnectionForm })}>
                    { vm.intl.formatMessage(CONNECTION_GROUPS_TEXT) }
                </div>
            </div>
            {vm.groupList.map(group => {
                const passportPreviewVM = vm.getPassportPreviewVM(group);
                return (
                    <div
                        key={group.meetingConnectionId}
                        className={classnames(
                            'connection-list__connection-wrapper connection-group-item', {
                                'connection-list__connection-wrapper--pl': vm.isMeetingConnectionForm,
                                'connection-group-item--room': vm.isEditRoomForm
                            }
                        )}
                    >
                        <ConnectionGroupListItem
                            group={group}
                            onEditGroup={vm.onEditGroup}
                            orderedConnections={vm.getOrderedConnections}
                            editButtonText={editButtonText}
                            editGroupPermission={editGroupPermission}
                            isSelected={vm.isGroupPopupOpen(group.meetingConnectionId)}
                            connectionGroupsPassportPreviewViewModel={passportPreviewVM}
                        />
                        <div className='connection-list__radio-default'>
                            <OERadioSingleOption
                                checked={vm.getDefaultConnectionId() === group.meetingConnectionId}
                                value={group.meetingConnectionId}
                                onToggle={vm.updateDefaultConnection}
                                allowUncheck={true}
                            />
                        </div>
                        {
                            vm.isMeetingConnectionForm &&
                            <div className='connection-list__settings-value'></div>
                        }
                        {
                            deleteGroupPermission
                            ? <div
                                onClick={() => vm.onDeleteConnectionGroup(group.meetingConnectionId)}
                                data-test-id="connection-delete-button"
                              >
                                    <label
                                        className='organization__remove-label m-right-10px'
                                    >
                                        { vm.intl.formatMessage(DELETE_TEXT) }
                                    </label>
                                </div>
                            : <div style={{width: '84px'}}></div>
                        }
                    </div>
                );
            })}
            {createGroupPermission &&
                <DefaultButton
                    className='connection-list__add-group-button add-line-to-table-btn'
                    modifier='slim'
                    isActive={vm.isNewGroupPopupOpened}
                    text={vm.intl.formatMessage(ADD_CONNECTION_GROUP_BTN_TEXT)}
                    onClick={openAddConnectionGroupPopup}
                />
            }
        </div>
    );
});